import { render, staticRenderFns } from "./UcRentalFormContracts.yaml?vue&type=template&id=045e48b6&component"
import script from "./UcRentalFormContracts.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalFormContracts.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports